(function () {
  const bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;

  // Debutの商品フォームを拾う（/cart/add の form）
  const form = document.querySelector('form[action^="/cart/add"]');
  if (!form) return;

  // 元の「カートに追加」ボタン（観測対象）
  const mainButton = form.querySelector('button[name="add"]');
  if (!mainButton) return;

  // 固定バー内のボタン
  const stickyBtn = bar.querySelector('[data-sticky-atc-btn]');
  if (!stickyBtn) return;

  // 数量input（メインフォーム）
  const qtyInputMain = form.querySelector('input[name="quantity"]');

  // 数量input（固定バー）※スマホで非表示・削除していてもOK
  const qtyInputSticky = bar.querySelector('input[name="quantity"]');

  // 変種ID（メインフォームが持っている hidden）
  const variantIdMain = form.querySelector('input[name="id"]');

  // ==========================
  // 表示制御
  // PC：常時表示 / スマホ：元ボタンが見えなくなったら表示
  // ==========================
  const isMobile = window.matchMedia('(max-width: 749px)').matches;

  if (!isMobile) {
    // PCは常時表示
    bar.classList.add('is-visible');
  } else {
    // スマホ：元のATCボタンが見えなくなったら表示
    const io = new IntersectionObserver(
      (entries) => {
        const isMainVisible = entries[0]?.isIntersecting;
        bar.classList.toggle('is-visible', !isMainVisible);
      },
      { threshold: 0.1 }
    );
    io.observe(mainButton);
  }

  // ==========================
  // 数量の同期（存在するものだけ）
  // ==========================
  const getQty = () => {
    // 固定側があればそれ優先、無ければメインフォーム
    const v = qtyInputSticky?.value || qtyInputMain?.value || '1';
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : 1;
  };

  const syncQty = (from, to) => {
    if (!from || !to) return;
    const v = from.value || '1';
    to.value = v;
  };

  if (qtyInputMain && qtyInputSticky) {
    // 初期同期
    syncQty(qtyInputMain, qtyInputSticky);

    // 双方向同期
    qtyInputMain.addEventListener('input', () => syncQty(qtyInputMain, qtyInputSticky));
    qtyInputSticky.addEventListener('input', () => syncQty(qtyInputSticky, qtyInputMain));
  }

  // ==========================
  // カート追加（DebutのAJAX設定に依存しないよう /cart/add.js を使用）
  // ==========================
  stickyBtn.addEventListener('click', async (e) => {
    e.preventDefault();

    // 変種IDが取れない場合は、元ボタンでフォールバック
    const variantId = variantIdMain?.value;
    if (!variantId) {
      mainButton.click();
      return;
    }

    // Sold out なら押せないようにする（念のため）
    if (mainButton.getAttribute('aria-disabled') === 'true' || mainButton.disabled) {
      return;
    }

    const quantity = getQty();

    stickyBtn.setAttribute('aria-busy', 'true');
    stickyBtn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: variantId, quantity }),
      });

      if (!res.ok) throw new Error('Add to cart failed');

      // DebutのAjax cart（カートドロワー等）がある場合に備えた更新通知
      // テーマ側でフックしていなければ何も起きません（安全）
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // もし「必ずカートページへ移動」したいなら下の1行を有効化
      // window.location.href = '/cart';

    } catch (err) {
      // うまく行かない場合は元のボタンに任せる
      mainButton.click();
    } finally {
      stickyBtn.removeAttribute('aria-busy');
      stickyBtn.disabled = false;
    }
  });
})();

